class RequestStatusData {
    static data() {
        return {
            new: {slug: "new", label: "Новый", short_label: "", class: "new"},
            in_work: {slug: "in_work", label: "В работе", short_label: "", class: "in_work"},
            not_answer: {slug: "not_answer", label: "Не отвечает", short_label: "", class: "not_answer"},
            non_call: {slug: "non_call", label: "Недозвон", short_label: "", class: "non_call"},
            arrived: {slug: "arrived", label: "В салоне", short_label: "", class: "arrived"},
            not_marked_in_salon: {slug: "not_marked_in_salon", label: "В салоне не отмечен", short_label: "", class: "not_marked_in_salon"},
            bought: {slug: "bought", label: "Купил", short_label: "", class: "bought"},
            will_arrive: {
                slug: "will_arrive", label: "Приедет", short_label: "", class: "will_arrive",
                children: [
                    {slug: null, label: "Не определен"},
                    {slug: "confirmed", label: "Подтвердил"},
                    {slug: "on_way", label: "В пути"},
                    {slug: "no_answer", label: "НО"},
                ],
            },
            approve: {
                slug: "approve", label: "Фильтр", short_label: "", class: "approve",
                children: [
                    {slug: null, label: "Не определен"},
                    {slug: "non_credit_region", label: "Некредит. регион"},
                    {slug: "credit_terms", label: "Кредит. условия"},
                    {slug: "have_not_car", label: "Нет авто"},
                    {slug: "legal_entity_or_leasing", label: "Юр.лицо|Лизинг"},
                    {slug: "third_person", label: "3-е лицо"},
                    {slug: "unsuitable_citizenship", label: "Не гражданин РФ"},
                    {slug: "cash", label: "Наличка"},
                    {slug: "other", label: "Другое"},
                ]
            },
            rejection: {
                slug: "rejection", label: "Отказ", short_label: "", class: "rejection",
                children: [
                    {slug: null, label: "Не определен"},
                    {slug: "bought", label: "Уже купил"},
                    {slug: "changed_mind", label: "Передумал"},
                    {slug: "postponed", label: "Отложил покупку"},
                    {slug: "ignoring", label: "Игнор"},
                    {slug: "reviews", label: "Отзывы"},
                    {slug: "other", label: "Другое"},
                ],
            },
            incorrect_data: {
                slug: "incorrect_data", label: "Некорректные данные", short_label: "Некорр. данные", class: "incorrect_data",
                children: [
                    {slug: null, label: "Не определен"},
                    {slug: "error", label: "Ошибка"},
                    {slug: "incorrect_number", label: "Некор. номер"},
                    {slug: "double", label: "Дубль заявки"},
                    {slug: "other", label: "Другое"},
                ],
            },
        };
    }
    static dataAsArray() {
        let arr = [];
        let data = this.data();
        for (status in data) {
            arr.push(data[status])
        }
        return arr;
    }
    static dataAsArrayForInvestor() {
        return this.dataAsArray().filter(function (o) {
            return ["bought"].indexOf(o.slug) !== -1;
        });
    }
    static forSelect() {
        return this.dataAsArray().map(function (item) {
            return {id: item.slug, text: item.label};
        })
    }
    static forSelectComposite() {
        let select = [];
        let data = this.data();
        for (let status_key in data) {
            let status_item = data[status_key];
            let select_item = {
                value: status_item.slug,
                label: status_item.short_label.length ? status_item.short_label : status_item.label,
            };
            if (status_item.children !== undefined) {
                select_item.children = [];
                status_item.children.forEach(child_item => {
                    select_item.children.push({
                        value: child_item.slug,
                        label: child_item.label,
                    })
                })
            }
            select.push(select_item);
        }
        return select;
    }

    static getStatusDataBySlug(slug) {
        return this.data()[slug];
    }
}

export default RequestStatusData;
